// extracted by mini-css-extract-plugin
export default {"metrics":"InsightsCardGI_metrics__hjXcn","metric":"InsightsCardGI_metric__nYPgN"};